import { ListItemText, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  listItemTextSecondary: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

interface DetailItemTextProps {
  label: string;
  value: React.ReactNode;
}

export default function DetailItemText({ label, value }: DetailItemTextProps) {
  const classes = useStyles();

  return (
    <ListItemText
      primary={label}
      secondary={value || ' - '}
      primaryTypographyProps={{
        variant: 'caption',
        color: 'textSecondary',
        noWrap: true,
      }}
      secondaryTypographyProps={{
        noWrap: true,
        component: 'span',
        title: typeof value === 'string' ? value : undefined,
        color: 'textPrimary',
        className: classes.listItemTextSecondary,
      }}
      style={{ margin: 0 }}
    />
  );
}
